import 'css-chunksrc/client/scenes/optimizedGantt/detailsView/details/dates/styles.scss';export default {
  "details": "_details_1wme9_1",
  "list": "_list_1wme9_16",
  "block": "_block_1wme9_20",
  "readOnly": "_readOnly_1wme9_31",
  "calendar": "_calendar_1wme9_42",
  "text": "_text_1wme9_51",
  "recalculated": "_recalculated_1wme9_60",
  "project": "_project_1wme9_65",
  "closedCalendar": "_closedCalendar_1wme9_73"
};